import React, { useRef, useState, useEffect } from 'react';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { uploadFile, ServiceAccountCreation, serviceFetchFailedLogs, serviceGetClinic, serviceGetDoctorByClinic, ServiceAllprogramList, serviceGetarea } from "../Services/Service";
import { CustomLoader, ModalBox, CustomLoading } from "../Services/CommonLibrary"
import History from './History';


function UpdateSummary(props) {
    const onReload = props.onReload;
    const [loading, setLoading] = useState(false);
    const initial = { practice_email: '', doctor_email: '', nhs_number: '', patient_name: '', patient_email: '', patient_mobile: '', program_name: '', ptHealthDataFile: '', drNotesFile: '', area_id: '', practicelist: [], drlist: [] }
    const [count, setCount] = useState(1);
    const [values, setValues] = useState([initial]);
    // const [practicelist, setPracticelist] = useState([]);
    const [arealist, setArealist] = useState([]);
    // const [drlist, setDrlist] = useState([]);
    const [programlist, setProgramlist] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalBody, setModalBody] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [intervalPopup, setIntervalPopup] = useState(false);
    const [uidStore, setUidStore] = useState('');
    const handleClose = () => setShowModal(false);
    const handleReloadClick = () => {
        onReload();
    };
    const [intervalId, setIntervalId] = useState(null);
    const buttonRef = useRef(null);
    useEffect(() => {
        areaListfunc();
        //practiceListfunc();
        //drListfunc();
        programListfunc();

    }, []);

    const practiceListfunc = async (areaId, index) => {
        const response = await serviceGetClinic(areaId);
        // console.log(response.data.data.clinic);
        // setPracticelist(response.data.data.clinic);
        const newValues = [...values];
        newValues[index]['practicelist'] = response.data.data.clinic;
        setValues(newValues);

    }
    const areaListfunc = async () => {
        const response = await serviceGetarea('');
        console.log(response.data.data.area);
        setArealist(response.data.data.area);

    }
    const drListfunc = async (clinicId, index) => {
        const response = await serviceGetDoctorByClinic(clinicId);
        // setDrlist(response.data.data.doctor);
        const newValues = [...values];
        newValues[index]['drlist'] = response.data.data.doctor;
        setValues(newValues);
    }
    const programListfunc = async () => {
        const response = await ServiceAllprogramList();
        setProgramlist(response.data.data);
    }
    const addTextBox = () => {
        setCount(count + 1);
        setValues([...values, initial]);
    };

    const removeTextBox = (index) => {
        // alert(index)
        setCount(count - 1);
        setValues(values.filter((value, i) => i !== index));
    };

    const handleChange = (event, index) => {

        const newValues = [...values];
        const name = event.target.name
        console.log(event.target.name)
        if (event.target.type == 'file') {
            // const id = event.target.getAttribute('data-index');
            console.log(event.target.files);
            if (event.target.files[0].type == 'application/pdf') {
                newValues[index][name] = event.target.files[0];
            } else {
                newValues[index][name] = '';
                document.getElementById(event.target.id).value = "";
            }

        } else if (event.target.name == "nhs_number") {

            const regex = /^[0-9-]*$/;
            if (event.target.value === '' || regex.test(event.target.value)) {
                newValues[index][name] = event.target.value;
            }

            // event.target.value =  event.target.value.replace(/\D/g, "");
            // newValues[index][name] = event.target.value;
        } else if (event.target.name == "area_id") {
            newValues[index][name] = event.target.value;
            newValues[index]['practice_email'] = '';
            newValues[index]['doctor_email'] = '';
            newValues[index]['drlist'] = [];

            const area_id = event.target.options[event.target.selectedIndex].getAttribute("data-areaid");
            practiceListfunc(area_id, index);

        } else if (event.target.name == "practice_email") {
            newValues[index][name] = event.target.value;
            const clinic_id = event.target.options[event.target.selectedIndex].getAttribute("data-clinicid");
            newValues[index]['doctor_email'] = '';
            newValues[index]['drlist'] = [];
            drListfunc(clinic_id, index);
        } else if (event.target.name == "patient_mobile") {
            newValues[index][event.target.name] = event.target.value.replace(/\D/g, "");
        } else {
            newValues[index][name] = event.target.value;
        }
        setValues(newValues);
    };

    const submitValues = (e) => {
        e.preventDefault();
        setLoading(true);
        let postValues = [...values];

        const formData = new FormData();
        values.forEach((formField, index) => {
            formData.append(`text[${index}]`, JSON.stringify(formField));
            formData.append(`ptHealthDataFile[${index}]`, formField.ptHealthDataFile);
            formData.append(`drNoteFile[${index}]`, formField.drNotesFile);
        });
        // setLoading(false);
        const fetchLiveUploadedData = (uidStore) => {
            serviceFetchFailedLogs(uidStore, 'live')
                .then((res) => {

                    if (res.data.data[0].queueStatus == 2) { setUidStore(''); clearInterval(intervalId); handleReloadClick(); }

                    const modalBodyComponent = res.data.data.length > 0 ?
                        res.data.data.map((item, i) =>
                            <tr key={i}>
                                <td>
                                    <span style={item.status == 'Success' ? { color: "green" } : { color: "red" }}>
                                        {item.status == 'Success' ? "Account Created" : "Invalid Data"}
                                    </span>
                                </td>
                                <td>
                                    <span style={item.statusMsg == 'Success' ? { color: "green" } : { color: "red" }}>{item.status == 'Success' ? "Account Created" : item.statusMsg}</span>
                                </td>
                                {item.rawJson.map((data, i) =>
                                    <td key={i}>{data}</td>
                                )}
                            </tr>
                        ) :
                        <tr><td colSpan="2">No Records</td></tr>;

                    const html = <><div className="table-responsive"><table className="table"><thead><tr><th scope="col">Status</th><th scope="col">Reason</th>
                        <th scope='col'>Practice Name</th>
                        <th scope='col'>Doctor email</th>
                        <th scope='col'>NHS number</th>
                        <th scope='col'>Patient Name</th>
                        <th scope='col'>Patient Email</th>
                        <th scope='col'>Patient Mobile</th>
                        <th scope='col'>Program Name</th>
                        <th scope='col'>Division</th>
                    </tr></thead><tbody>{modalBodyComponent}</tbody></table></div>{res.data.data[0].queueStatus != 2 ? <CustomLoading /> : null}</>

                    setModalBody(html);
                    handleReloadClick();

                }
                );
        }
        ServiceAccountUpdate(formData)
            .then((response) => {
                setLoading(false);

                if (typeof (response) !== 'undefined') {
                    let clas = (response.data.status == "1") ? 'success' : 'danger';

                    let uploadStatus = response.data.status;
                    if (uploadStatus == 3) {
                        setShowModal(true)
                        // console.log(response.data.data.message);
                        const modalBodyComponent = response.data.data.message.length > 0 ? response.data.data.message.map((data, i) => (
                            <tr key={i}>
                                <td><span style={data[10] == 'Success' ? { color: "green" } : { color: "red" }}>{data[10] == 'Success' ? 'Valid Data' : 'Invalid Data'}</span></td>
                                <td >
                                    <span style={data[10] == 'Success' ? { color: "green" } : { color: "red" }}>
                                        {data[10] == 'Success' ? 'Valid Data' :
                                            data[10].split(',').map((item, index) => {
                                                return (index === 0) ? item : [<br key={index} />, item];
                                            })
                                        }
                                    </span>
                                </td>
                                <td>{data[0]}</td>
                                <td>{data[1]}</td>
                                <td>{data[2]}</td>
                                <td>{data[3]}</td>
                                <td>{data[4]}</td>
                                <td>{data[5]}</td>
                                <td>{data[6]}</td>
                                <td>{data[7]}</td>
                            </tr>
                        )) : <tr><td colSpan="2">No Records</td></tr>;
                        const html = <div className="table-responsive"><table className="table"><thead><tr> <th scope='col'>Status</th>
                            <th scope='col'>Reason</th>
                            <th scope='col'>Practice Name</th>
                            <th scope='col'>Doctor email</th>
                            <th scope='col'>NHS number</th>
                            <th scope='col'>Patient Name</th>
                            <th scope='col'>Patient Email</th>
                            <th scope='col'>Patient Mobile</th>
                            <th scope='col'>Program Name</th>
                            <th scope='col'>Division</th></tr></thead><tbody>{modalBodyComponent}</tbody></table></div>
                        setModalBody(html);
                        setModalTitle(<span style={{ "backgroundColor": "#e3b6b6", padding: "5px", borderRadius: "10px" }}> 0 Accounts Created. Please Resolve Below Errors And Update Patient details again.</span>)
                    } else if (uploadStatus == 1) {
                        setUidStore(response.data.uid);
                        console.log("2nd call")
                        setShowModal(true);
                        setModalTitle('Alert!')
                        setModalBody(<span> Patient Details added Successfully, Account creation is in progress...... </span>);
                        setIntervalPopup(true);

                        const timeoutId = setTimeout(() => {
                            setShowModal(false);
                            fetchLiveUploadedData(response.data.uid);
                            setShowModal(true);
                            setIntervalPopup(true);
                            // console.log("timeout ===",response.data.uid);
                            setModalTitle('Status: Uploaded File. Account Creation In-Progress...')
                            handleReloadClick();
                        }, 3000);

                    } else if (uploadStatus == 4) {
                        setShowModal(true);
                        setModalTitle('Alert!');
                        setModalBody(response.data.data.message);
                    }


                    // -------------------------------------
                    if (response.data.status == "1") {
                        setValues([initial]);
                        document.getElementById('ptHealthDataFile_0').value = "";
                        document.getElementById('drNotesFile_0').value = "";

                    }
                    handleReloadClick();
                    // onShowAlert(response.data.data.message,true,clas);    
                }
            })
        // console.log(values);
    };

    return (
        <>
            <div className='table-responsive'>
                <div className=''>


                    <form className='' onSubmit={submitValues}>
                        <div className="table-responsive text-nowrap mb-2">

                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        {/* <th>#</th> */}
                                        <th>*NHS No.</th>
                                        <th>*Patient Name</th>
                                        <th>Patient Email</th>
                                        {/* <th>*Patient Mobile</th> */}
                                        <th>*Division</th>
                                        <th>Practice</th>
                                        <th>Doctor</th>
                                        <th>*Program</th>
                                        <th>*Patient Summary (only pdf)</th>
                                        <th>Doctor Note (only pdf)</th>
                                        {/* <th>Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {values.map((value, index) => (
                                        <tr key={index}>
                                            {/* <th scope="row">{index+1}</th> */}
                                            <td><input style={{ width: "auto" }} className="form-control form-control-sm centered-placeholder" required value={value.nhs_number} name="nhs_number" onChange={(event) => handleChange(event, index)} placeholder="NHS Number" maxLength="10" type="text" /></td>
                                            <td><input style={{ width: "auto" }} className="form-control form-control-sm centered-placeholder" required value={value.patient_name} name="patient_name" onChange={(event) => handleChange(event, index)} placeholder="Patient Name" type="text" /></td>
                                            <td><input style={{ width: "auto" }} className="form-control form-control-sm centered-placeholder" value={value.patient_email} name="patient_email" onChange={(event) => handleChange(event, index)} placeholder="Patient Email" type="email" /></td>
                                            {/* <td><input style={{ width: "auto" }} className="form-control form-control-sm centered-placeholder" required value={value.patient_mobile} name="patient_mobile" onChange={(event) => handleChange(event, index)} placeholder="Patient Mobile" type="text" maxLength='10' /></td> */}

                                            <td><select style={{ width: "auto" }} id="area_id" name="area_id" value={value.area_id} className='form-control form-control-sm' required onChange={(event) => handleChange(event, index)} >
                                                <option value="">-- SELECT Division --</option>

                                                {arealist.map((data, i) => (
                                                    <option value={data.areaName} data-areaid={data.areaId} key={i}>{data.areaName}</option>
                                                ))}
                                            </select>
                                            </td>
                                            <td><select style={{ width: "auto" }} id="clinicSelect" name="practice_email" value={value.practice_email} className='form-control form-control-sm' onChange={(event) => handleChange(event, index)} >
                                                <option value="">-- SELECT Practice --</option>

                                                {value.practicelist.length > 0 ? value.practicelist.map((data, i) => (
                                                    <option value={data.email} data-clinicid={data.clinicId} key={i}>{data.name}</option>
                                                )) : null}
                                            </select>
                                            </td>
                                            <td>
                                                <select style={{ width: "auto" }} id="drSelect" name="doctor_email" value={values[index].doctor_email} className='form-control form-control-sm' onChange={(event) => handleChange(event, index)} >
                                                    <option value="">-- SELECT Doctor --</option>

                                                    {value.drlist.length > 0 ? value.drlist.map((data, i) => (
                                                        <option value={data.email} key={i}>{data.drName}</option>
                                                    )) : null}
                                                </select>
                                            </td>

                                            <td>
                                                <select style={{ width: "auto" }} id="programSelect" name="program_name" value={values[index].program_name} className='form-control form-control-sm' required onChange={(event) => handleChange(event, index)} >
                                                    <option value="">-- SELECT Program --</option>

                                                    {programlist.length > 0 ? programlist.map((data, i) => (
                                                        <option value={data.programName} key={i}>{data.programName}</option>
                                                    )) : null}
                                                </select>

                                            </td>
                                            <td><input id={`ptHealthDataFile_${index}`} style={{ width: "auto" }} className="form-control form-control-sm" required type="file" data-index={index} name="ptHealthDataFile" accept="application/pdf" onChange={(event) => handleChange(event, index)} /></td>
                                            <td><input id={`drNotesFile_${index}`} style={{ width: "auto" }} className="form-control form-control-sm" type="file" data-index={index} name="drNotesFile" accept="application/pdf" onChange={(event) => handleChange(event, index)} /></td>

                                            {/* <td>{count > 1 ? <button type="button" style={{ width: "auto" }} className="btn btn-danger btn-sm" onClick={() => removeTextBox(index)}><i className="bi bi-trash"></i></button> : null}</td> */}
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                        {/* {count < 100 ? <button type="button" style={{ width: "auto" }} className="btn btn-success btn-sm me-3 mb-2" onClick={addTextBox}><i className="bi bi-plus"></i> Add More</button> : null} */}
                        <button type="submit" style={{ width: "auto" }} className="btn btn-primary btn-sm mb-2" name="submit" >Submit ({values.length})</button>
                    </form>
                </div>
            </div>


            {showModal ? <ModalBox handleClose={handleClose} showModaln={showModal} titlen={modalTitle} bodyn={modalBody} /> : null}
            {loading ? <CustomLoader /> : null}
        </>
    );
}
export default UpdateSummary;